import { render, staticRenderFns } from "./RemindMailForm.vue?vue&type=template&id=5cc2de97&scoped=true&"
import script from "./RemindMailForm.vue?vue&type=script&lang=js&"
export * from "./RemindMailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc2de97",
  null
  
)

export default component.exports